<style scoped>

  .tab-segment {
    min-height: 350px;
  }

  .ui.basic.segment {
    min-height: 450px;
  }

</style>

<template>
  
  <div class="ui grid animated fadeIn">
    <div class="ui sixteen wide column">
      <div class="ui basic segment no-margin no-padding" :class="{ loading }">
        <table class="ui celled selectable tablet stackable table">
          <thead v-if="$isDesktop">
            <tr>
              <th>Evento</th>            
              <th>Data</th>
              <th>Hora</th>
              <th>Usuário</th>
              <th v-if="hasComments">Observações</th>
            </tr>  
          </thead>
          <tbody>
            <tr v-for="(event, index) in events">
              <td>
                <strong class="mobile-only">Evento: </strong>
                <cert-event :event="event.event" />
              </td>
              <td>
                <strong class="mobile-only">Data: </strong> {{ $formatDate(event.createdAt) }}
              </td>
              <td>
                <strong class="mobile-only">Hora: </strong> {{ $formatTime(event.createdAt) }}
              </td>
              <td>
                <strong class="mobile-only">Usuário: </strong> {{ event.user.name + ' ' + event.user.lastName }}
              </td>
              <td v-if="hasComments">
                <strong class="mobile-only">Observações: </strong> {{ event.comments }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>    

</template>

<script>

  import CertService from "@/services/cert-service"
  import CertEvent from "@/components/cert-event"

  const service = new CertService()

  export default {
    
    name: "CertHistoricTab",

    data() {
      return {
        loading: true,
        events: [],
      }
    },
    
    props: ["cert"],

    components: {
      CertEvent,
    },

    created() {
      this.loadEvents()
    },    

    computed: {

      hasComments() {

        for (let event of this.events) {
          if (event.comments)
            return true
        }

        return false
      },
    },

    methods: {

      async loadEvents() {

        this.loading = true

        try {

          this.events = await service.getEvents(this.cert.id)          

        } catch (error) {

          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },
    },
  }

</script>